import { AppModule } from '@app/app.module';
import { TableFilter, TableInputFilter, TableSelectFilter } from '@beego/ngx-table';
import { LocationProvider } from '@internal-providers/location.provider';
import { translate } from '@shared-libs/helpers';

export class EventsTableFactory {
	public static getFilters(): { [key: string]: TableFilter } {
		const locationProvider = AppModule.injector.get(LocationProvider);

		return {
			termFilter: new TableInputFilter({
				property: 'searchTerm',
				name: translate('FILTERS.SEARCH_TERM.TITLE'),
				placeholder: translate('FILTERS.SEARCH_TERM.PLACEHOLDER'),
			}),

			locationFilter: new TableSelectFilter({
				property: 'Location.id',
				data: async () =>
					(await locationProvider.getAll()).map((location) => ({
						name: location.place,
						value: location.id,
					})),

				name: translate('FILTERS.LOCATION.TITLE'),
				resource: 'online',
			}),

			ownEventsFilter: new TableSelectFilter({
				property: 'Employee.id',
				data: [
					{ name: translate('FILTERS.OWN_EVENTS.OPTIONS.YES'), value: true },
					{ name: translate('FILTERS.OWN_EVENTS.OPTIONS.NO'), value: false },
				],

				name: translate('FILTERS.OWN_EVENTS.TITLE'),
				resource: 'online',
			}),
		};
	}
}
